import React, { useState } from "react";

import { Botao, Box, CampoEstatico, TipoCampoEstatico } from "@intechprev/componentes-web";
import { PlanoVinculadoEntidade } from "../../../../entidades";

interface IProps {
  ultimaContribuicao: any | null;
  plano: PlanoVinculadoEntidade | null;
}

export const Saldo: React.FC<IProps> = ({
  ultimaContribuicao,
  plano
}) => {
  const [Esconder, setEsconder] = useState<boolean>(true);

  const MascaraValorEscondido = (valor: number) => {
    if (Esconder) {
      const valorEscondido = `R$ ${valor.toFixed(2).replaceAll(".", ",").replaceAll(/\d/gm, "*")}`;
      return valorEscondido;
    }
    return valor;
  }

  if (plano !== undefined && plano.CD_SIT_PLANO !== "30" && ultimaContribuicao !== null && ultimaContribuicao !== undefined) {
    const dataReference = ultimaContribuicao.cotas[0].DT_IND;
    const contribuicaoParticipante = ultimaContribuicao.saldosSem[0].CONTRIB_PARTICIPANTE;
    const valoresPortados = (ultimaContribuicao.saldosCom[0].CONTRIB_PARTICIPANTE || 0) + (ultimaContribuicao.saldosCom[0].CONTRIB_EMPRESA || 0);
    const contribuicoesPatronais = ultimaContribuicao.saldosSem[0].CONTRIB_EMPRESA;
    const total = contribuicaoParticipante + valoresPortados + contribuicoesPatronais;
    const saldoAcomulado =
      ((ultimaContribuicao.saldosSem[0].QTD_COTA_RP_EMPRESA || 0) +
        (ultimaContribuicao.saldosSem[0].QTD_COTA_RP_PARTICIPANTE || 0) +
        (ultimaContribuicao.saldosCom[0].QTD_COTA_RP_EMPRESA || 0) +
        (ultimaContribuicao.saldosCom[0].QTD_COTA_RP_PARTICIPANTE || 0)
      ) * ultimaContribuicao.cotas[0].VALOR_IND;
    const rendimento = saldoAcomulado - total;
    return (
      <Box renderRow={true} titulo={"Seu Saldo de Contas"} label={`em ${dataReference}`}>
        <div className={"table-responsive"}>
          <table className={"table table-striped table-sm"}>
            <caption>
              {`Valor da cota em ${dataReference}: ${String(ultimaContribuicao.cotas[0].VALOR_IND).replace(".", ",")}`}
            </caption>
            <tbody>
              <tr>
                <td>{"Suas Contribuições"}</td>
                <td className={"text-right"}>
                  <CampoEstatico
                    valor={MascaraValorEscondido(contribuicaoParticipante)}
                    tipo={Esconder ? TipoCampoEstatico.texto : TipoCampoEstatico.dinheiro}
                  />
                </td>
              </tr>
              <tr>
                <td>{"Valores Portados"}</td>
                <td className={"text-right"}>
                  <CampoEstatico
                    valor={MascaraValorEscondido(valoresPortados)}
                    tipo={Esconder ? TipoCampoEstatico.texto : TipoCampoEstatico.dinheiro}
                  />
                </td>
              </tr>
              <tr style={{ "borderBottom": "2px solid #8e8e8e" }}>
                <td>{"Contribuições Patronais"}</td>
                <td className={"text-right"}>
                  <CampoEstatico
                    valor={MascaraValorEscondido(contribuicoesPatronais)}
                    tipo={Esconder ? TipoCampoEstatico.texto : TipoCampoEstatico.dinheiro}
                  />
                </td>
              </tr>
              <tr style={{ "borderBottom": "2px solid #8e8e8e" }}>

                <th>{"Contribuições Totais"}</th>

                <th className={"text-right"}>
                  <CampoEstatico
                    valor={MascaraValorEscondido(total)}
                    tipo={Esconder ? TipoCampoEstatico.texto : TipoCampoEstatico.dinheiro}
                  />
                </th>
              </tr>
              <tr>
                <th>{"Rendimento do Plano"}</th>
                <th className={"text-right"}>
                  <CampoEstatico
                    valor={MascaraValorEscondido(rendimento)}
                    tipo={Esconder ? TipoCampoEstatico.texto : TipoCampoEstatico.dinheiro}
                  />
                </th>
              </tr>
              <tr>
                <th className={"alert-info alert pl-2 py-3"}>
                  Parabéns!<br />
                  Seu Saldo Acumulado Atualizado:
                </th>
                <th className={"alert-info alert pr-2 py-3 text-right align-middle"}>
                  <CampoEstatico
                    valor={MascaraValorEscondido(saldoAcomulado)}
                    tipo={Esconder ? TipoCampoEstatico.texto : TipoCampoEstatico.dinheiro}
                  />
                </th>
              </tr>
            </tbody>
          </table>
          <Botao
            className={"mt-2"}
            titulo={Esconder ? "Mostrar" : "Esconder"}
            onClick={() => setEsconder(!Esconder)}
            icone={Esconder ? "fas fa-eye" : "fas fa-eye-slash"}
            usaLoading
          />
        </div>
      </Box>
    )
  }

  return (
    null
  );
}